module.exports = {
  props: {
    errors: {
      type: Object,
      required: true,
    },
  },
}